webpackJsonp([133434392651373],{

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	__webpack_require__(35);
	
	__webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/CDPQ_mem1.jpg";
	
	var icon2 = "https://winpeforum.com/assets/elements/AparajitaAhuja.jpeg";
	
	var icon3 = "https://winpeforum.com/assets/elements/MansiAggarwal.png";
	
	var icon4 = "https://winpeforum.com/assets/elements/DianeJegam.jpg";
	
	var icon5 = "https://winpeforum.com/assets/elements/PadmajaRuparel.jpg";
	
	var duration = 400;
	
	var I14 = "https://www.winpeforum.com/assets/sheshines/24jan2024/14.jpg";
	var I15 = "https://www.winpeforum.com/assets/sheshines/24jan2024/15.jpg";
	var I16 = "https://www.winpeforum.com/assets/sheshines/24jan2024/16.jpg";
	var I17 = "https://www.winpeforum.com/assets/sheshines/24jan2024/17.jpg";
	var I18 = "https://www.winpeforum.com/assets/sheshines/24jan2024/18.jpg";
	var I19 = "https://www.winpeforum.com/assets/sheshines/24jan2024/19.jpg";
	
	var II14 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/14.jpg";
	var II15 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/15.jpg";
	var II16 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/16.jpg";
	var II17 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/17.jpg";
	var II18 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/18.jpg";
	var II19 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/19.jpg";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	
	    _this.Speaker1 = [{
	      imgUrl: icon1,
	      desc: "<div>\n            Anita M. George is Executive Vice-President and Deputy Head of CDPQ Global. She fills a key role in developing CDPQ\u2019s activities in its three priority international areas: the United States/Latin America, Europe and Asia Pacific. She actively participates in positioning CDPQ internationally, as well as developing and executing its globalization strategy. In addition to her role managing the international offices, Ms. George contributes to diversifying the portfolio by taking a holistic view in approaching the various markets. She sits on CDPQ\u2019s Investment-Risk Committee.<br/><br/>\n        \n        Ms. George joined CDPQ in April 2016 as Managing Director, South Asia. She was then appointed as Executive Vice-President, Growth Markets and prior to her current role was Executive Vice-President and Head of Strategic Partnerships, Growth Markets. She has extensive knowledge of several of these markets, in addition to possessing a strong ability to develop and strengthen enduring and quality partnerships.<br/><br/>\n        \n        She has a strong track record in managing infrastructure investment portfolios on a global scale. Prior to joining CDPQ, she was Senior Director of the World Bank\u2019s Energy and Extractive Industries Global Practice. She also held the positions of Director, Infrastructure and Natural Resources of the International Finance Corporation, a member of the World Bank Group, and Head of Siemens Financial Services in India. Her various roles have led her to work in several regions of the world, including Europe, Asia, the Middle East, Africa and Latin America.<br/><br/>\n        \n        Ms. George holds a BA in Economics and Spanish from Smith College, in Massachusetts, and a Masters in Economics and an MBA in Finance from Boston University.\n        \n                </div>",
	      name: "Anita George",
	      post: "<div>Co-Founder<br/>\n            Edhina Capital\n            \n            </div>"
	    }, {
	      imgUrl: icon2,
	      desc: "<div>\n            Aparajita is Partner and CFO at CX Partners, a leading Private Equity group in the Indian mid-market. Currently, she is on the Board of Betterplace. Previously she has served on the boards of DT Group, Veeda Clinical Research and TSI Pvt Ltd. She has been part of the vibrant Private Equity sector since 2008.<br/><br/>\n        \n            She is a qualified Chartered Accountant and holds an undergraduate degree in Commerce from the University of Delhi.\n            \n        \n        \n            </div>",
	      name: "Aparajita Ahuja",
	      post: "<div>Partner & CFO<br/>CX Partners\n        \n        \n            </div>"
	    }, {
	      imgUrl: icon4,
	      desc: "<div>\n            Diane Jegam is the Regional Director of Proparco South Asia, covering the origination of both debt and equity investments in the region. Since joining French Development Agency in 2008, Diane held different positions within the group with a focus in Africa and has worked in numerous impactful sectors.\n            <br/><br/>\n        Before this posting in India, she held the position of Deputy Director of the French Development Agency (AFD) in Dakar (2017 \u2013 2021), one of the important office of AFD Group network.\n        \n        \n        \n            </div>",
	      name: "Diane Jegam",
	      post: "<div>Regional Director South Asia\t<br/>\n            Proparco\n            \n            \n            </div>"
	    }, {
	      imgUrl: icon3,
	      desc: "<div>\n            Mansi Aggarwal is a Partner at Alkemi Growth Capital. She has build and invest in leading and sustainable healthcare and consumer companies in India, with a portfolio of over 10 (and counting!) innovative and disruptive startups. With over 15+ years of experience as an investor, banker, and entrepreneur, she has a deep understanding of the opportunities and challenges in these sectors, and a passion for creating positive social impact.\n    <br/><Br/>\n    Her journey as a business leader began with her education in dental surgery and MBA, followed by involvement in the Stanford Biodesign program, where she co-founded and exited a medical device startup. She also hold 6 patents in healthcare and biotechnology and has been recognized for her achievements in Indian and global forums. She leverages her diverse background, skills, and network to support the growth and success of the companies she invest in and partner with.\n      \n            \n            </div>",
	      name: "Mansi Aggarwal",
	      post: "<div>Partner\n    <br/>\n            Alkemi Growth Capital\n            \n      \n      \n            </div>"
	    }, {
	      imgUrl: icon5,
	      desc: "<div>\n            Padmaja Ruparel is nationally recognized as a key player in the Indian entrepreneurial ecosystem and has helped co-found many of the relevant institutions, besides being an active Angel investor herself. Her operating experience spans large corporates, M&A, and startups/early stage companies. \n            <br/><br/>\n        She has been awarded as one of the 'Top 50 Most Powerful Women in Business' by Fortune India for 2017, 2018 2019, listed in Forbes India's WPower Trailblazers and \u201C30 Most Powerful Women in India\u201D by Business Today for 3 years running. The Women Economic Forum recognized her with its \u201CWomen of the Decade in Investment Banking\u201D award. \n        <br/><br/>\n        She is Co-Founder & President of Indian Angel Network (IAN), India's first and now possibly one of the world's largest group of business angels, comprising the who's who of successful entrepreneurs and dynamic CEOs from India and overseas. She built IAN from inception, making it within 15 years a unique institution globally, with close to 500 investors across 10 countries and a portfolio of 175+ companies in 7 countries, spanning 17 sectors. She has operationalised IAN's international operations in London - making it the only angel group in the world to set up operations outside of its home country. Padmaja has been nominated as Co Chair of Global Business Angel Network (GBAN). She is a member of the National Expert Advisory Committee on Innovation, Incubation and Technology Entrepreneurship. She is a member of several committees of BIRAC (Dept. of Biotech, Govt. of India), various committees of the Ministry of Finance, DPIIT, & SEBI. \n        <br/><br/>\n        Padmaja is the Senior Managing Partner of the IAN Fund, a uniquely differentiated Fund which along with IAN, is set to create the largest horizontal platform in India for investing in seed and early stage ventures. \n        <br/><br/>\n        She is a member of the Governing Council of EM3 Services, a nation building venture seeking to create a paradigm shift in the Indian agricultural sector by improving productivity. Padmaja is an Independent Director on the Boards of Avendus Finance Pvt. Ltd. & Ester Industries Ltd. \n        <br/><br/>\n        Apart from cofounding IAN, she also set up and operationalised the Delhi chapter of The Indus Entrepreneurs (TIE) the world's largest organization focused on entrepreneurship with over 16,000 members across more than 60 chapters across 14 countries. She also established a unique model of an incubator, in partnership with the Indian Government, leveraging 400 mentors to provide mentoring & domain expertise to around 50 young fledgling incubated companies. She played a key role as Executive Director in building the Indian Venture Capital Association, India's oldest and largest association of VC and PE firms. Currently, she is a member of IVCA's Limited Partners Council. \n        <br/><br/>\n        She helped the creation of the Lankan Angel Network in Sri Lanka. She contributed actively in the Planning Commission's Committee on \u201CAngel & Early Stage Investing in India\u201D which resulted in a seminal report: \u201CCreating a Vibrant Entrepreneurial Ecosystem in India\u201D.\n        <br/><br/>\n        In her corporate avatar at Xansa India, (Xansa was a US$800mn company listed on LSE before being acquired by Steria), she led several functions over a 16 year period : handled recruitment operations, built and successfully executed an innovative brand and communication strategy and led the corporate social responsibility initiative which engaged employees, clients as also the government. She was a key member of the corporate strategy and M&A team as the Company went public, forged joint ventures and the final acquisition of the Indian company. \n        <br/><br/>\n        Padmaja picked up entrepreneurial strings very early in her career - she revived and grew the family real estate business in Calcutta - growing from 50,000 sq ft to over 250,000 sq ft over 2 years and turned it around to become a profitable business. \n        <br/><br/>\n        A graduate with English Honours, Padmaja then completed her MBA as well as Chartered Accountancy (Intermediate) with her internship with S.R. Batliboi (an E&Y group company).\n        \n        \n        \n            </div>",
	      name: "Padmaja Ruparel",
	      post: "<div>Co-Founder & President<br/>\n            Indian Angel Network\n            \n            \n            </div>"
	    }];
	    _this.CollegiumsImages = [{ id: 45, ImgSrc: I14, ImgSrc1: II14 }, { id: 19, ImgSrc: I15, ImgSrc1: II15 }, { id: 49, ImgSrc: I16, ImgSrc1: II16 }, { id: 21, ImgSrc: I17, ImgSrc1: II17 }, { id: 20, ImgSrc: I18, ImgSrc1: II18 }, { id: 14, ImgSrc: I19, ImgSrc1: II19 }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "EmpowerHer: Winpe PEVC Career Portal",
	        image: "https://winpeforum.com/assets/ignite/cover.png",
	        description: "CV In, Stress Out: Let's Ignite Up Your PEVC Future. Maximize Impact, Harness The Power of PEVC Insights and Accelerate Your Job Search with Our Panel of Experts.",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper", style: { paddingTop: '110px', minHeight: 'auto' } },
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "a",
	              { href: "https://forms.gle/JS5XPGKmCV5TJzjz7" },
	              "   ",
	              _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/ignite/Home3.jpg", alt: "About Image", style: { width: '100%' } })
	            )
	          ),
	          " "
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container ", style: { paddingTop: '40px', minHeight: '540px' } },
	          _react2.default.createElement(
	            "div",
	            { className: "col-lg-5 col-md-5 col-sm-12" },
	            _react2.default.createElement("br", null),
	            "   ",
	            _react2.default.createElement(
	              "h1",
	              { className: " title", style: { color: '#bf2026', fontWeight: '700', textAlign: 'left' } },
	              "IGNITE THE POSSIBILITIES"
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { width: '100%' } },
	              _react2.default.createElement(
	                "ul",
	                { style: { textAlign: 'left', color: '#22316b', fontSize: '20px', fontWeight: '600', lineHeight: '30px'
	                  } },
	                _react2.default.createElement(
	                  "li",
	                  { style: { paddingBottom: '10px' } },
	                  "Exclusive Job Opportunities"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { style: { paddingBottom: '10px' } },
	                  "Power-packed Resource Hub                 "
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { style: { paddingBottom: '10px' } },
	                  "Robust Community Access"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { style: { paddingBottom: '10px' } },
	                  "Power Training Sessions             "
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { style: { paddingBottom: '10px' } },
	                  "Masterclasses with Experts  "
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { style: { paddingBottom: '10px' } },
	                  "CV Visibility\u2013Get Your CV on Recruiters' Radar"
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { style: { paddingBottom: '10px' } },
	                  "Insider Tips from Recruiters                "
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { style: { paddingBottom: '10px' } },
	                  "1:1 Sessions with Industry Leaders"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-lg-7 col-md-7 col-sm-12" },
	            _react2.default.createElement(
	              "a",
	              { href: "https://chat.whatsapp.com/JeAI8cBNsvSBtwY5jzNk6Y", target: "_blank" },
	              _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/ignite/whatsapp4.png", alt: "About Image", style: { width: '100%', paddingTop: '53px' } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { backgroundImage: 'url(https://winpeforum.com/assets/ignite/bg5.png)', height: 'auto', minHeight: '540px', width: '100%', backgroundSize: 'cover', paddingBottom: '45px' } },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { width: '100%', textAlign: 'left', color: '#ffffff', paddingLeft: '15px', fontSize: '21px', fontWeight: '500' } },
	              " Power Up with Our Free PEVC Career-Boosting"
	            ),
	            _react2.default.createElement(
	              "h1",
	              { className: " title", style: { color: '#ffffff', textAlign: 'left', marginTop: '0px', paddingLeft: '15px', fontWeight: '700' } },
	              "RESOURCES"
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-sm-6 col-md-5-5 col-lg-1-5" },
	              _react2.default.createElement(
	                "a",
	                { href: "/trainings/" },
	                _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/ignite/pw1.png", alt: "About Image", style: { width: '100%' } })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-sm-6 col-md-3-5 col-lg-1-5" },
	              _react2.default.createElement(
	                "a",
	                { href: "/RecruiterInsights/" },
	                _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/ignite/pw2.png", alt: "About Image", style: { width: '100%' } })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-sm-6 col-md-2-5 col-lg-1-5" },
	              _react2.default.createElement(
	                "a",
	                { href: "/PeerSpeak/" },
	                _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/ignite/pw3.png", alt: "About Image", style: { width: '100%' } })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-sm-6 col-md-4-5 col-lg-1-5" },
	              _react2.default.createElement(
	                "a",
	                { href: "/VisionaryVoices/" },
	                _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/ignite/pw4.png", alt: "About Image", style: { width: '100%' } })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-sm-6 col-md-4-5 col-lg-1-5" },
	              _react2.default.createElement(
	                "a",
	                { href: "#" },
	                _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/ignite/pw5.png", alt: "About Image", style: { width: '100%' } })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { backgroundImage: 'url(https://winpeforum.com/assets/ignite/bg9.jpg)', height: 'auto', minHeight: '540px', width: '100%', backgroundSize: 'cover', paddingBottom: '45px' } },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "h1",
	              { className: " title", style: { color: '#ffffff', textAlign: 'left', marginTop: '0px', paddingLeft: '15px', fontWeight: '600', fontFamily: 'Lato' } },
	              "Power ",
	              _react2.default.createElement(
	                "span",
	                { style: { color: '#bf2026', fontStyle: 'italic' } },
	                "Sessions:"
	              ),
	              " Calendar"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { width: '100%', textAlign: 'left', color: '#ffffff', paddingLeft: '15px', fontSize: '21px', fontWeight: '500' } },
	              " Join us on an impactful learning journey with our exclusive training sessions,",
	              _react2.default.createElement("br", null),
	              " tailored to ignite your skills and knowledge."
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-md-3" },
	              _react2.default.createElement(
	                "a",
	                { href: "/IgniteWorkshopOnFinancialModelling/" },
	                _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/aug1.png", alt: "About Image", style: { width: '100%' } })
	              ),
	              " "
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-md-3" },
	              _react2.default.createElement(
	                "a",
	                { href: "/IgniteSession16May2026/" },
	                _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/ignite/power1111.png", alt: "About Image", style: { width: '100%' } })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-md-3" },
	              _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/ignite/power33.png", alt: "About Image", style: { width: '100%' } })
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-md-3" },
	              _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/ignite/power44.png", alt: "About Image", style: { width: '100%' } })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container ", style: { paddingTop: '30px' } },
	          _react2.default.createElement(
	            "h1",
	            { className: " title", style: { color: '#bf2026', textAlign: 'left', fontWeight: '700' } },
	            "TESTIMONIALS"
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "div",
	            { className: "col-lg-4" },
	            _react2.default.createElement(
	              "div",
	              { style: { backgroundColor: '#f2f2f2', height: '390px' } },
	              _react2.default.createElement(
	                "p",
	                { style: { fontSize: '20px', padding: '35px', textAlign: 'center', fontFamily: 'Lato' } },
	                "This was a very insightful, valuable session - appreciate the panelists for taking out their time - and also for my CV review :) And big thanks to Winpe for hosting it"
	              ),
	              _react2.default.createElement("br", null),
	              " ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h3",
	                { style: { color: '#22316b', fontWeight: '600', textAlign: 'center', fontFamily: 'Lato' } },
	                "- Dhwani Nanavati"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-lg-4" },
	            _react2.default.createElement(
	              "div",
	              { style: { backgroundColor: '#d7d7d7', height: '390px' } },
	              _react2.default.createElement(
	                "p",
	                { style: { fontSize: '20px', padding: '35px', textAlign: 'center', fontFamily: 'Lato' } },
	                _react2.default.createElement("br", null),
	                "   ",
	                _react2.default.createElement("br", null),
	                " ",
	                _react2.default.createElement("br", null),
	                "Amazing platform for women willing to pursue their career in PE. Kudos !!"
	              ),
	              _react2.default.createElement("br", null),
	              " ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h3",
	                { style: { color: '#22316b', fontWeight: '600', textAlign: 'center', fontFamily: 'Lato' } },
	                "- Snehansu Pradhan"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-lg-4" },
	            _react2.default.createElement(
	              "div",
	              { style: { backgroundColor: '#f2f2f2', height: '390px' } },
	              _react2.default.createElement(
	                "p",
	                { style: { fontSize: '20px', padding: '35px', textAlign: 'center', fontFamily: 'Lato' } },
	                "Shoutout to Winpe Forum for giving me the opportunity to interact with Capital Markets expert Bhavna Thakur! The 1:1 session was extremely insightful. Great initiative and looking forward to more such opportunities! This was great\u2026"
	              ),
	              _react2.default.createElement(
	                "h3",
	                { style: { color: '#22316b', fontWeight: '600', textAlign: 'center', fontFamily: 'Lato' } },
	                "- Shriya Bahul"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-6" },
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("iframe", {
	              className: "resp-iframe",
	              style: { margin: "0 auto", height: '300px' },
	              width: "100%",
	              src: "https://www.youtube.com/embed/KMV9_jzBqy4?si=-nzl6EeuKApwqGQG",
	              frameBorder: "0",
	              allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
	              allowFullScreen: true
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-6" },
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("iframe", {
	              className: "resp-iframe",
	              style: { margin: "0 auto", height: '300px' },
	              width: "100%",
	              src: "https://www.youtube.com/embed/GEApxHfrYC4?si=S9o2QrWr-QPN0lL9",
	              frameBorder: "0",
	              allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
	              allowFullScreen: true
	            })
	          )
	        ),
	        _react2.default.createElement("br", null),
	        " ",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "div",
	          { style: { backgroundImage: 'url(https://winpeforum.com/assets/ignite/bg8.jpg)', height: 'auto', width: '100%', backgroundSize: 'cover', paddingBottom: '45px' } },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/ignite/whojoin.png", alt: "About Image", style: { width: '100%' } })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { "class": "container" },
	          _react2.default.createElement(
	            "div",
	            { "class": "row", style: { paddingTop: '30px' } },
	            _react2.default.createElement(
	              "div",
	              { "class": "col-md-12" },
	              _react2.default.createElement(
	                "h1",
	                { className: " title", style: { color: '#bf2026', textAlign: 'left', fontWeight: '700' } },
	                "FAQs"
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { "class": "tabs" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tab" },
	                  _react2.default.createElement("input", { type: "checkbox", id: "chck1" }),
	                  _react2.default.createElement(
	                    "label",
	                    { "class": "tab-label", "for": "chck1" },
	                    "What is Winpe Ignite?"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "tab-content" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Winpe Ignite is an initiative designed to support and enhance women's entry into the Private Equity and Venture Capital (PEVC) sector. It offers a range of resources, including training programs, sessions with CHROs, and job postings to help women advance their careers in this field."
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tab" },
	                  _react2.default.createElement("input", { type: "checkbox", id: "chck2" }),
	                  _react2.default.createElement(
	                    "label",
	                    { "class": "tab-label", "for": "chck2" },
	                    "  What does the components of the Winpe Ignite portal?"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "tab-content" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "The Winpe Ignite Portal provides access to various features including:",
	                      _react2.default.createElement(
	                        "ul",
	                        null,
	                        _react2.default.createElement(
	                          "li",
	                          null,
	                          "Specialized training programs tailored to the PEVC sector."
	                        ),
	                        _react2.default.createElement(
	                          "li",
	                          null,
	                          "Exclusive sessions with CHROs and industry leaders for career guidance and networking."
	                        ),
	                        _react2.default.createElement(
	                          "li",
	                          null,
	                          "Job postings and career opportunities within the PEVC sector."
	                        ),
	                        _react2.default.createElement(
	                          "li",
	                          null,
	                          "3-5 days short training courses in collaboration with prestigious training and knowledge providers (Paid)"
	                        ),
	                        _react2.default.createElement(
	                          "li",
	                          null,
	                          "Links to Recommended free online knowledge resources"
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tab" },
	                  _react2.default.createElement("input", { type: "checkbox", id: "chck3" }),
	                  _react2.default.createElement(
	                    "label",
	                    { "class": "tab-label", "for": "chck3" },
	                    " How can I sign-up for Winpe Ignite?       "
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "tab-content" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "You can sign-up by visiting our website and following the sign-up process."
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tab" },
	                  _react2.default.createElement("input", { type: "checkbox", id: "chck4" }),
	                  _react2.default.createElement(
	                    "label",
	                    { "class": "tab-label", "for": "chck4" },
	                    "Are the training programs and sessions live or recorded?"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "tab-content" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "The training programs and sessions with CHROs are typically conducted live."
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tab" },
	                  _react2.default.createElement("input", { type: "checkbox", id: "chck5" }),
	                  _react2.default.createElement(
	                    "label",
	                    { "class": "tab-label", "for": "chck5" },
	                    "Can I access Winpe Ignite from anywhere?"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "tab-content" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Yes, it is accessible online from anywhere, allowing you to take advantage of the resources and opportunities at your convenience."
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tab" },
	                  _react2.default.createElement("input", { type: "checkbox", id: "chck6" }),
	                  _react2.default.createElement(
	                    "label",
	                    { "class": "tab-label", "for": "chck6" },
	                    "  What kind of job postings will be available on the portal?"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "tab-content" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "The job postings on the Ignite Portal will feature a variety of opportunities within the PEVC sector, including roles in private equity, venture capital, and related fields. These postings will be curated to match the interests and career goals of women in the sector."
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tab" },
	                  _react2.default.createElement("input", { type: "checkbox", id: "chck7" }),
	                  _react2.default.createElement(
	                    "label",
	                    { "class": "tab-label", "for": "chck7" },
	                    "How often is new content and job postings updated on the portal?"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "tab-content" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "Content and job postings are updated regularly to ensure that you have access to the latest opportunities and resources. Registrants will receive notifications about new updates and upcoming events."
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tab" },
	                  _react2.default.createElement("input", { type: "checkbox", id: "chck8" }),
	                  _react2.default.createElement(
	                    "label",
	                    { "class": "tab-label", "for": "chck8" },
	                    "What should I do if I encounter any issues or have feedback about the portal?"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "tab-content" },
	                    _react2.default.createElement(
	                      "p",
	                      null,
	                      "If you experience any issues or have feedback about the portal, please contact our support team at info@winpeforum.com or at +91 8920503049 (WhatsApp only). We are here to assist you and ensure you have a smooth experience."
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null)
	            )
	          )
	        ),
	        _react2.default.createElement("div", null)
	      ),
	      _react2.default.createElement(TeamModal, {
	        show: isShow,
	        onHide: this.togglePopUp,
	        activeItem: this.state.activeItem
	      })
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-winpe-ignite-index-js-dea81a43dc06eb1102e2.js